import { ECheckoutSource, IPlan } from '../../models/checkout.model';

export const calculateDiscount = (plan: IPlan): number => {
  if (!plan || !plan.price_before_discount || !plan.price) {
    return 0;
  }
  return Math.round(
    ((plan.price_before_discount - plan.price) / plan.price_before_discount) *
      100
  );
};
// checks if source value exist in ECheckoutSource else return  fallback
export const getCheckoutSourceFromFlag = (
  flagValue: string,
  fallback: ECheckoutSource = ECheckoutSource.premiumModal
): ECheckoutSource => {
  const isValidSource = Object.values(ECheckoutSource).includes(
    flagValue as ECheckoutSource
  );
  return isValidSource ? (flagValue as ECheckoutSource) : fallback;
};
